export function timed<TFunc extends (...args: unknown[]) => unknown>(
  operation: string,
  fn: TFunc
): ReturnType<TFunc> {
  if (PRODUCTION) {
    return fn() as ReturnType<TFunc>
  }

  // eslint-disable-next-line no-console
  console.time(operation)
  const result = fn() as ReturnType<TFunc>
  // eslint-disable-next-line no-console
  console.timeEnd(operation)

  return result
}
